<app-header></app-header>
<div class="app-layout">
    <app-sidebar></app-sidebar>

    <main class="workspace">
        <section class="page-hero">
            <div class="hero-top">
                <h3 class="hero-heading">Link Analysis</h3>
                <!-- Full Automated Search hidden for now — drill-down only.
                <div class="workspace-tabs">
                    <button type="button" class="workspace-tab" [class.active]="activeWorkspace === 'automated'" (click)="setWorkspace('automated')">
                        <i class="fas fa-bolt"></i>
                        Full Automated Search
                    </button>
                    <button type="button" class="workspace-tab" [class.active]="activeWorkspace === 'drill_down'" (click)="setWorkspace('drill_down')">
                        <i class="fas fa-project-diagram"></i>
                        Drill-Down Search
                    </button>
                </div>
                -->
                <div class="credits-display">
                    <div class="credits-inline">
                        <span class="credits-inline-label">Remaining:</span>
                        <span class="credits-inline-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></span>
                    </div>
                    <button type="button" class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">
                        <i class="fas fa-coins credits-icon"></i>
                        Buy Credits
                    </button>
                </div>
            </div>
            <p class="subcopy">
                Start an interactive drill-down search from a phone, email, or username.
            </p>
        </section>

        <div class="search-card-container" *ngIf="isServiceDisabled">
            <div class="service-disabled-warning">
                <div class="warning-icon">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <h2 class="warning-title">Search temporarily unavailable</h2>
                <p class="warning-message">
                    We're experiencing a temporary service issue. You can still access and export your previous search history below.
                </p>
            </div>
        </div>

        <!-- Full Automated Search form hidden for now.
        <section class="surface form-surface" *ngIf="activeWorkspace === 'automated'">
            <div class="mode-switch">
                <button type="button" class="mode-pill" [class.active]="rootType === 'phone'" (click)="setRootType('phone')">
                    <i class="fas fa-mobile-alt"></i>
                    Phone root
                </button>
                <button type="button" class="mode-pill" [class.active]="rootType === 'email'" (click)="setRootType('email')">
                    <i class="fas fa-envelope"></i>
                    Email root
                </button>
                <button type="button" class="mode-pill" [class.active]="rootType === 'username'" (click)="setRootType('username')">
                    <i class="fas fa-user"></i>
                    Username root
                </button>
            </div>

            <div class="form-grid automated-form-grid">
                <div class="form-col">
                    <label class="field">
                        <span>{{ automatedInputLabel }}</span>
                        <div class="input-shell">
                            <i class="fas" [ngClass]="automatedInputIcon"></i>
                            <input [(ngModel)]="rootValue" [type]="automatedInputType" [placeholder]="automatedInputPlaceholder" />
                        </div>
                    </label>
                </div>

                <label class="field photo-field">
                    <span>Photo URLs (optional)</span>
                    <div class="input-shell textarea-shell">
                        <i class="fas fa-link"></i>
                        <textarea [(ngModel)]="photoUrlsText" rows="1" placeholder="One image URL per line."></textarea>
                    </div>
                </label>

                <label class="field layer-field">
                    <span>Auto-expand depth</span>
                    <div class="mode-switch layer-switch">
                        <button
                            type="button"
                            class="mode-pill"
                            *ngFor="let option of maxLayerOptions"
                            [class.active]="maxLayer === option.value"
                            [title]="option.hint"
                            (click)="maxLayer = option.value"
                        >
                            {{ option.label }}
                        </button>
                    </div>
                    <p class="field-note">
                        Layer 1 is the root OSINT + leak ring. Extra layers auto-search discovered
                        emails, phones, and images (name/username stay manual). Default is
                        <strong>2 layers</strong>. You can stop automation anytime on the result page.
                    </p>
                </label>
            </div>

            <div class="form-footer">
                <p class="helper-copy">
                    <strong class="helper-copy-label">
                        {{ hasActiveSubscription ? 'Underlying charges only:' : 'Subscription status:' }}
                    </strong>
                    {{ subscriptionHint }}
                </p>
                <button type="button" class="primary-btn start-analysis-btn" [class.is-disabled]="!canStartInvestigation" [disabled]="!canStartInvestigation" [attr.aria-disabled]="!canStartInvestigation" [attr.title]="canStartInvestigation ? 'Start link analysis' : subscriptionHint" (click)="createInvestigation()">
                    {{ loading ? 'Starting investigation...' : 'Start link analysis' }}
                    <i class="fas fa-arrow-right" *ngIf="!loading"></i>
                </button>
            </div>
        </section>
        -->

        <section class="surface form-surface drilldown-surface" *ngIf="!isServiceDisabled && activeWorkspace === 'drill_down'">
            <div class="drilldown-search-row">
                <div class="drilldown-input-col">
                    <span class="drilldown-field-label">{{ drillDownInputLabel }}</span>
                    <div class="input-shell drilldown-input-shell">
                        <i class="fas" [ngClass]="drillDownInputIcon"></i>
                        <input [(ngModel)]="drillDownQueryValue" [type]="drillDownInputType" [placeholder]="drillDownInputPlaceholder" />
                    </div>
                </div>
                <div class="drilldown-type-col">
                    <span class="drilldown-field-label drilldown-type-label">Search type</span>
                    <div class="mode-switch drilldown-type-switch">
                        <button type="button" class="mode-pill" [class.active]="drillDownQueryType === 'phone'" (click)="setDrillDownQueryType('phone')">
                            <i class="fas fa-mobile-alt"></i>
                            Phone
                        </button>
                        <button type="button" class="mode-pill" [class.active]="drillDownQueryType === 'email'" (click)="setDrillDownQueryType('email')">
                            <i class="fas fa-envelope"></i>
                            Email
                        </button>
                        <button type="button" class="mode-pill" [class.active]="drillDownQueryType === 'username'" (click)="setDrillDownQueryType('username')">
                            <i class="fas fa-user"></i>
                            Username
                        </button>
                    </div>
                </div>
            </div>
            <p class="field-note drilldown-field-note">
                Expand results into OSINT, leak, AI, and face-search branches from the graph canvas.
                Additional actions use configured credits per search.
            </p>

            <div class="form-footer drilldown-form-footer">
                <p class="helper-copy">
                    <strong class="helper-copy-label">
                        {{ hasActiveSubscription ? 'First search charge:' : 'Subscription status:' }}
                    </strong>
                    {{ hasActiveSubscription ? estimatedCreditLabel : subscriptionHint }}
                </p>
                <button type="button" class="primary-btn start-analysis-btn" [class.is-disabled]="!canStartInvestigation" [disabled]="!canStartInvestigation" [attr.aria-disabled]="!canStartInvestigation" [attr.title]="canStartInvestigation ? 'Start drill-down search' : subscriptionHint" (click)="createDrillDownInvestigation()">
                    {{ loading ? 'Starting drill-down search...' : 'Start drill-down search' }}
                    <i class="fas fa-arrow-right" *ngIf="!loading"></i>
                </button>
            </div>
        </section>

        <section class="history-surface">
            <div class="section-header">
                <div>
                    <h2>Recent link analysis</h2>
                </div>
            </div>

            <div *ngIf="loadingHistory" class="empty-state">Loading recent investigations...</div>

            <div *ngIf="!loadingHistory && !recentInvestigations.length" class="empty-state">
                No saved investigations yet.
            </div>

            <div class="investigations-table-wrap" *ngIf="!loadingHistory && recentInvestigations.length">
                <table class="investigations-table">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Target</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Photos</th>
                            <th>Nodes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="investigation-row" *ngFor="let item of recentInvestigations" (click)="openInvestigation(item.link_analysis_id)">
                            <td>
                                <span class="type-badge" [class.type-drilldown]="isDrillDownInvestigation(item)" [class.type-automated]="!isDrillDownInvestigation(item)">
                                    {{ getHistoryModeLabel(item) }}
                                </span>
                            </td>
                            <td>
                                <div class="target-cell">
                                    <span class="target-type">{{ getHistoryRootType(item) }}</span>
                                    <strong class="target-value">{{ getHistoryRootValue(item) }}</strong>
                                </div>
                            </td>
                            <td class="date-cell">
                                {{ item.created_on | date: 'MMM d, y, h:mm:ss a' }}
                            </td>
                            <td>
                                <span class="status-badge" [class.status-completed]="isCompletedStatus(item)" [class.status-processing]="isProcessingStatus(item)">
                                    <i class="fas fa-check-circle" *ngIf="isCompletedStatus(item)"></i>
                                    <i class="fas fa-spinner fa-spin" *ngIf="isProcessingStatus(item)"></i>
                                    {{ getStatusLabel(item) }}
                                </span>
                            </td>
                            <td class="meta-cell photos-cell">{{ getPhotoInputLabel(item) }}</td>
                            <td class="meta-cell">
                                <span class="nodes-cell">
                                    <i class="fas fa-project-diagram" aria-hidden="true"></i>
                                    <span>{{ getNodeCount(item) }}</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </main>

    <div class="search-loading-overlay" *ngIf="loading" role="status" aria-live="polite" aria-busy="true">
        <div class="search-loading-card">
            <i class="fas fa-spinner fa-spin search-loading-icon" aria-hidden="true"></i>
            <strong>{{ loadingTitle }}</strong>
            <span>{{ loadingDetail }}</span>
        </div>
    </div>
</div>